module.exports = __webpack_public_path__ + "img/a037f85.png";